import { render, staticRenderFns } from "./greed_raid_modal.vue?vue&type=template&id=96d8a552&scoped=true"
import script from "./greed_raid_modal.vue?vue&type=script&lang=ts"
export * from "./greed_raid_modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d8a552",
  null
  
)

export default component.exports